import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import type {
  BackendLandingPageAsset,
  BackendProject,
  BackendProjectDraftAssetsArgs,
  BackendQueryProjectArgs,
} from 'src/types/backend';

const QUERY = gql`
  query QueryCODraftAssets($projectId: Int!, $segmentId: ID) {
    project(id: $projectId) {
      id
      draftAssets(segmentId: $segmentId) {
        edges {
          node {
            id
            type
            cssSelector
            status
            variants {
              id
              isOrigin
              isDisabled
              screenshotBase64
              screenshotUrl
              savedVariation {
                id
                text
              }
            }
          }
        }
      }
    }
  }
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  segmentId?: BackendProjectDraftAssetsArgs['segmentId'];
};

export const queryCODraftAssets = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });

  const project = getSingleProp<BackendProject>(result.data);
  return unwrapEdges<BackendLandingPageAsset>(
    project?.draftAssets?.edges as Array<{ node: BackendLandingPageAsset }> | undefined
  );
};
